import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material'
import React from 'react'
import '../asset/css/BuyonlineModal.css'
import CloseIcon from '@mui/icons-material/Close';

const BuyOnlineModal = ({open,setOpne,productDetailData}) => {
  return (
    <Dialog
        open={open}
        onClose={() => setOpne(false)}
        maxWidth={"lg"}
      >
        <DialogTitle className='online_heading' style={{ backgroundColor: "#3dcd58" }}>
          <b className='headingtag'>Buy online</b>
          <div className='close_icon' onClick={()=>{setOpne(false)}}><CloseIcon /></div>
        </DialogTitle>
        <DialogContent style={{ fontSize: 14, padding: 10 }}>
          <Grid container spacing={2}>
            <Grid item xs={2}>
              <div>
                <img src={productDetailData.MainImageUrl} alt="Image" className="img-fluid" height={"100%"} width={"100%"} />
              </div>
            </Grid>
            <Grid item xs={10}>
              <div style={{ paddingTop: "10px" }}>
                <p style={{ fontWeight: "bold" }}>{productDetailData.ProductId}</p>
                <p>{productDetailData.ProductDescription}</p>
              </div>

            </Grid>
          </Grid>
          <div>
            <Grid container spacing={1}>

              {productDetailData.RetailerProducts?.length > 0 ? productDetailData.RetailerProducts.map((item, i) => (
                <Grid item xs={3} >
                  <div className="retailerProduct">
                    <div>
                      <a href={item.ClickThruUrl} target="_blank" rel="noreferrer">
                        <img src={item.RetailerLogoUrl} alt="Product Image" className="pi" />
                      </a>
                       
                    </div>
                    <div className="productStatus"  >

                      {
                        item.StockPrices?.map((item, i) => (
                          item.Stock === "InStock" ? <span className="instock">In stock</span>
                            :
                            <span className="avilabletoorder">Available to order</span>

                        ))
                      }
                    </div>
                    <div className="productname">
                      <h4>{item.prod_name}</h4>
                    </div>
                  </div>



                </Grid>
              )) : <h6>No Data Found </h6>}




            </Grid>
          </div>
        </DialogContent>
      </Dialog>
  )
}

export default BuyOnlineModal